import { RestMethod } from '../../_helpers/ApiConfig/RestMethod'
// import FilterResponse from '../../_helpers/FilterResponse'
// import toastr from 'toastr'

export const optionMasterService = {
    optionMasterList,
    optionMasterByID,
    createOptionMaster,
    updateOptionMaster,
    updateOptionMasterStatus,
    deleteOptionMaster,
    optionMasterByType
}

async function optionMasterList() {
    try {
        const response = await RestMethod.GET('/optionMaster');
        return response.data;
    }
    catch (error) {
        console.log("error detected while fetching data from api");
        return null;
    }
}

async function optionMasterByID(id, projectId) {
    try {
        const response = await RestMethod.GET('/configuration/' + projectId + '/optionMaster/' + id);
        return response.data;
    }
    catch (error) {
        console.log("error detected while fetching data from api");
        return null;
    }
}
async function optionMasterByType(id, projectId, filter) {
    let filter1 = filter !== undefined ? filter:""
    try {
        const response = await RestMethod.GET('/configuration/' + projectId + '/optionMaster/type/' + id+filter1 );
        return response.data;
    }
    catch (error) {
        console.log("error detected while fetching data from api");
        return null;
    }
}

async function createOptionMaster(data, projectId) {
    try {
        const response = await RestMethod.POST('/configuration/' + projectId + '/optionMaster', data);
        return response.data;
    }
    catch (error) {
        console.log("error detected while fetching data from api");
        return null;
    }
}

async function updateOptionMaster(id, projectId, data) {
    try {
        const response = await RestMethod.PUT('/configuration/' + projectId + '/optionMaster/' + id, data);
        return response.data;
    }
    catch (error) {
        console.log("error detected while fetching data from api");
        return null;
    }
}

async function updateOptionMasterStatus(id) {
    try {
        const response = await RestMethod.PUT('/configuration/1/optionMaster/status/' + id);
        return response.data;
    }
    catch (error) {
        console.log("error detected while fetching data from api");
        return null;
    }
}

async function deleteOptionMaster(id, projectId) {
    try {
        const response = await RestMethod.DELETE('/configuration/' + projectId + '/optionMaster/' + id);
        return response.data;
    }
    catch (error) {
        console.log("error detected while fetching data from api");
        return null;
    }
}